<template>
  <ul class="displayLinks">
    <li
      v-for="(link, linkIndex) in links"
      :key="linkIndex"
      class="displayLink"
    >
      <a
        :href="link.url"
        class="highlight underline"
        target="_blank"
      >{{ link.text }}</a>
    </li>
  </ul>
</template>

<script>
export default {
    name: 'DisplayLinks',
    props: {
        links: { type: Array, required: true },
    },
};
</script>

<style lang="scss" scoped>
.displayLinks {
    list-style: none;
}
.displayLink {
    &:not(:last-child) {
        margin-bottom: 10px;
    }
}
</style>
